// User-facing fallback for route-level errors.
//
// Security note: only render a generic message; never echo
// `error.message` blindly because it can include backend details that
// should not surface to users (per react-rewrite-plan §9.3).

import { useRouteError } from 'react-router-dom';
import { Button } from '@/shared/ui/button';

export function RouteErrorFallback() {
  // We read the route error so React Router stops bubbling, but we do
  // not display its contents directly.
  useRouteError();

  function handleRetry() {
    // Reload the current route. Simple and easy to reason about; a
    // smarter retry (router reset) is fine to add later.
    window.location.reload();
  }

  return (
    <section role="alert" aria-live="assertive" className="flex flex-col gap-2 p-8">
      <h1 className="text-lg font-semibold">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">We could not load this page. Please try again.</p>
      <Button variant="secondary" onClick={handleRetry} className="w-fit">
        Try again
      </Button>
    </section>
  );
}
